// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.weather-wrapper {
  height: 100%;
  width: 100%;
  margin: 0;
  padding: 0 1rem;
  display: grid;
  grid-template-rows: 1fr 1fr;
}

.weather-card-content-top {
  width: 100%;
  text-align: center;
  justify-content: center;
}

.weather-card-content-row {
  width: 100%;
  flex-grow: 1;
  flex-direction: column;
  text-align: center;
  justify-content: center;
  align-items: flex-start;
}
.weather-card-content-row ion-col {
  --ion-grid-column-padding: 0;
}

.weather-card-content-row-title {
  width: 100%;
  flex-direction: row;
  justify-content: center;
  color: var(--color-black-light);
}

.weather-card-content-row-weather {
  width: 100%;
  display: grid;
  justify-content: center;
  align-items: center;
  grid-template-columns: 3.25rem 1fr auto;
  overflow: hidden;
}

.weather-card-content-left {
  margin: 0;
  --ion-grid-column-padding: 0;
  overflow: hidden;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  text-align: left;
  vertical-align: middle;
  font-family: Calibri;
  color: var(--color-black-light);
  font-weight: 600;
  font-size: 1.3125rem;
  opacity: 0;
  animation: title-appear 500ms ease-out 500ms forwards;
}

.weather-card-content-right {
  margin: 0;
  --ion-grid-column-padding: 0;
  overflow: hidden;
  width: 100%;
  height: -moz-fit-content;
  height: fit-content;
  text-align: center;
  vertical-align: middle;
  font-family: Calibri;
  color: var(--color-black-light);
  margin-top: 0px;
  text-align: right;
  font-weight: 600;
  font-size: 1.3125rem;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.weather-icon-cont {
  margin: 0;
  height: 48px;
  width: 48px;
}
.weather-icon-cont .weather-icon {
  width: auto;
  height: auto;
  max-height: 100%;
  max-width: 100%;
}

@keyframes title-appear {
  from {
    opacity: 0;
    transform: translateX(150px);
  }
  to {
    opacity: 1;
    transform: translateX(0px);
  }
}
/* dark theme styles */
.dark .weather-card-content-row-title {
  color: var(--color-black-dark);
}
.dark .weather-card-content-left {
  color: var(--color-black-dark);
}
.dark .weather-card-content-right {
  color: var(--color-black-dark);
}`, "",{"version":3,"sources":["webpack://./src/app/components/widgets/conditions-widget/conditions-widget.component.scss","webpack://./../../../../../Ryan%20Ticer/source/repos/seacom3/ui/src/app/components/widgets/conditions-widget/conditions-widget.component.scss"],"names":[],"mappings":"AAAA;EACE,YAAA;EACA,WAAA;EACA,SAAA;EACA,eAAA;EACA,aAAA;EACA,2BAAA;ACCF;;ADEA;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;ACCF;;ADEA;EACE,WAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;ACCF;ADCE;EACE,4BAAA;ACCJ;;ADGA;EACE,WAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;ACAF;;ADGA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,uCAAA;EACA,gBAAA;ACAF;;ADGA;EACE,SAAA;EACA,4BAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;EAAA,mBAAA;EACA,gBAAA;EACA,sBAAA;EACA,oBAAA;EACA,+BAAA;EACA,gBAAA;EACA,oBAAA;EACA,UAAA;EACA,qDAAA;ACAF;;ADGA;EACE,SAAA;EACA,4BAAA;EACA,gBAAA;EACA,WAAA;EACA,wBAAA;EAAA,mBAAA;EACA,kBAAA;EACA,sBAAA;EACA,oBAAA;EACA,+BAAA;EAEA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,uBAAA;ACDF;;ADIA;EACE,SAAA;EACA,YAAA;EACA,WAAA;ACDF;ADGE;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,eAAA;ACDJ;;ADKA;EACE;IACE,UAAA;IACA,4BAAA;ECFF;EDKA;IACE,UAAA;IACA,0BAAA;ECHF;AACF;ADMA,sBAAA;AAEE;EACE,8BAAA;ACLJ;ADQE;EACE,8BAAA;ACNJ;ADSE;EACE,8BAAA;ACPJ","sourcesContent":[".weather-wrapper {\r\n  height: 100%;\r\n  width: 100%;\r\n  margin: 0;\r\n  padding: 0 1rem;\r\n  display: grid;\r\n  grid-template-rows: 1fr 1fr;\r\n}\r\n\r\n.weather-card-content-top {\r\n  width: 100%;\r\n  text-align: center;\r\n  justify-content: center;\r\n}\r\n\r\n.weather-card-content-row {\r\n  width: 100%;\r\n  flex-grow: 1;\r\n  flex-direction: column;\r\n  text-align: center;\r\n  justify-content: center;\r\n  align-items: flex-start;\r\n\r\n  ion-col {\r\n    --ion-grid-column-padding: 0;\r\n  }\r\n}\r\n\r\n.weather-card-content-row-title {\r\n  width: 100%;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  color: var(--color-black-light);\r\n}\r\n\r\n.weather-card-content-row-weather {\r\n  width: 100%;\r\n  display: grid;\r\n  justify-content: center;\r\n  align-items: center;\r\n  grid-template-columns: 3.25rem 1fr auto;\r\n  overflow: hidden;\r\n}\r\n\r\n.weather-card-content-left {\r\n  margin: 0;\r\n  --ion-grid-column-padding: 0;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  height: fit-content;\r\n  text-align: left;\r\n  vertical-align: middle;\r\n  font-family: Calibri;\r\n  color: var(--color-black-light);\r\n  font-weight: 600;\r\n  font-size: 1.3125rem;\r\n  opacity: 0;\r\n  animation: title-appear 500ms ease-out 500ms forwards;\r\n}\r\n\r\n.weather-card-content-right {\r\n  margin: 0;\r\n  --ion-grid-column-padding: 0;\r\n  overflow: hidden;\r\n  width: 100%;\r\n  height: fit-content;\r\n  text-align: center;\r\n  vertical-align: middle;\r\n  font-family: Calibri;\r\n  color: var(--color-black-light);\r\n\r\n  margin-top: 0px;\r\n  text-align: right;\r\n  font-weight: 600;\r\n  font-size: 1.3125rem;\r\n  white-space: nowrap;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.weather-icon-cont {\r\n  margin: 0;\r\n  height: 48px;\r\n  width: 48px;\r\n\r\n  .weather-icon {\r\n    width: auto;\r\n    height: auto;\r\n    max-height: 100%;\r\n    max-width: 100%;\r\n  }\r\n}\r\n\r\n@keyframes title-appear {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateX(150px);\r\n  }\r\n\r\n  to {\r\n    opacity: 1;\r\n    transform: translateX(0px);\r\n  }\r\n}\r\n\r\n/* dark theme styles */\r\n.dark {\r\n  .weather-card-content-row-title {\r\n    color: var(--color-black-dark);\r\n  }\r\n\r\n  .weather-card-content-left {\r\n    color: var(--color-black-dark);\r\n  }\r\n  \r\n  .weather-card-content-right {\r\n    color: var(--color-black-dark);\r\n  }\r\n}\r\n",".weather-wrapper {\n  height: 100%;\n  width: 100%;\n  margin: 0;\n  padding: 0 1rem;\n  display: grid;\n  grid-template-rows: 1fr 1fr;\n}\n\n.weather-card-content-top {\n  width: 100%;\n  text-align: center;\n  justify-content: center;\n}\n\n.weather-card-content-row {\n  width: 100%;\n  flex-grow: 1;\n  flex-direction: column;\n  text-align: center;\n  justify-content: center;\n  align-items: flex-start;\n}\n.weather-card-content-row ion-col {\n  --ion-grid-column-padding: 0;\n}\n\n.weather-card-content-row-title {\n  width: 100%;\n  flex-direction: row;\n  justify-content: center;\n  color: var(--color-black-light);\n}\n\n.weather-card-content-row-weather {\n  width: 100%;\n  display: grid;\n  justify-content: center;\n  align-items: center;\n  grid-template-columns: 3.25rem 1fr auto;\n  overflow: hidden;\n}\n\n.weather-card-content-left {\n  margin: 0;\n  --ion-grid-column-padding: 0;\n  overflow: hidden;\n  width: 100%;\n  height: fit-content;\n  text-align: left;\n  vertical-align: middle;\n  font-family: Calibri;\n  color: var(--color-black-light);\n  font-weight: 600;\n  font-size: 1.3125rem;\n  opacity: 0;\n  animation: title-appear 500ms ease-out 500ms forwards;\n}\n\n.weather-card-content-right {\n  margin: 0;\n  --ion-grid-column-padding: 0;\n  overflow: hidden;\n  width: 100%;\n  height: fit-content;\n  text-align: center;\n  vertical-align: middle;\n  font-family: Calibri;\n  color: var(--color-black-light);\n  margin-top: 0px;\n  text-align: right;\n  font-weight: 600;\n  font-size: 1.3125rem;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n.weather-icon-cont {\n  margin: 0;\n  height: 48px;\n  width: 48px;\n}\n.weather-icon-cont .weather-icon {\n  width: auto;\n  height: auto;\n  max-height: 100%;\n  max-width: 100%;\n}\n\n@keyframes title-appear {\n  from {\n    opacity: 0;\n    transform: translateX(150px);\n  }\n  to {\n    opacity: 1;\n    transform: translateX(0px);\n  }\n}\n/* dark theme styles */\n.dark .weather-card-content-row-title {\n  color: var(--color-black-dark);\n}\n.dark .weather-card-content-left {\n  color: var(--color-black-dark);\n}\n.dark .weather-card-content-right {\n  color: var(--color-black-dark);\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
